(function () {

    const translations = {
        en: {
            minQty: 'Quantity',
            discount: 'Discount',
            buy: 'Buy {qty} +',
            off: '{discount}% Off'
        },
        nl: {
            minQty: 'Minimale hoev.',
            discount: 'Korting',
            buy: 'Koop {qty} +',
            off: '{discount}% korting'
        },
        de: {
            minQty: 'Mindestmenge',
            discount: 'Rabatt',
            buy: 'Kaufen Sie {qty} +',
            off: '{discount}% Rabatt'
        },
        fr: {
            minQty: 'Qté minimale',
            discount: 'Remise',
            buy: 'Achetez {qty} +',
            off: '{discount}% de réduction'
        },
        it: {
            minQty: 'Qtà minima',
            discount: 'Sconto',
            buy: 'Acquista {qty} +',
            off: '{discount}% di sconto'
        },
        sv: {
            minQty: 'Minsta antal',
            discount: 'Rabatt',
            buy: 'Köp {qty} +',
            off: '{discount}% rabatt'
        }
    };

    function getCurrentLanguage() {
        let lang = (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : null;
        if (!lang) {
            const urlParams = new URLSearchParams(window.location.search);
            lang = urlParams.get('locale') || 'en';
        }
        if (!translations[lang]) lang = 'en';
        return lang;
    }

    function translateHulkWidget() {
        const lang = getCurrentLanguage();
        const t = translations[lang];

        const table = document.querySelector('.hulkapps-table');
        if (!table) return;

        const headers = table.querySelectorAll('thead th');
        if (headers.length >= 2) {
            headers[0].textContent = t.minQty;
            headers[1].textContent = t.discount;
        }

        const rows = table.querySelectorAll('tbody tr');
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            if (cells.length >= 2) {
                const qtyMatch = cells[0].textContent.match(/(\d+)/);
                if (qtyMatch) {
                    const qty = qtyMatch[1];
                    const span = cells[0].querySelector('.hulk-offer-text');
                    cells[0].childNodes[0].nodeValue = t.buy.replace('{qty}', qty) + ' ';
                }

                const priceSpan = cells[1].querySelector('.hulkapps-price');
                if (priceSpan) {
                    const discMatch = priceSpan.textContent.match(/(\d+)/);
                    if (discMatch) {
                        const discount = discMatch[1];
                        priceSpan.textContent = t.off.replace('{discount}', discount);
                    }
                }
            }
        });
    }

    function repositionHulkWidget() {
        const hulkContainer = document.querySelector('.hulkapps-volumes');
        const addToCartSection = document.querySelector('.product-info__add-to-cart');
        
        if (!hulkContainer || !addToCartSection) {
            console.log('[HULK] Elements not found for repositioning');
            return;
        }
        
        // Verplaats de Hulk widget NA de add-to-cart container
        addToCartSection.insertAdjacentElement('afterend', hulkContainer);
    }

   function toggleCompanyAccountBlock() {
    const hulkContainer = document.querySelector('.hulkapps-volumes');
    const hulkTable = document.querySelector('.hulkapps-table');
    const companyAccountBlock = document.querySelector('.create-company-account');
    
    if (!companyAccountBlock) {
        return;
    }
    
    // Check of Hulk container bestaat, zichtbaar is EN een tabel bevat
    const isHulkVisible = hulkContainer && 
                         hulkContainer.offsetParent !== null && 
                         hulkTable && 
                         hulkContainer.offsetHeight > 0;
    
    if (isHulkVisible) {
        companyAccountBlock.style.display = 'block';
    } else {
        companyAccountBlock.style.display = 'none';
    }
}


    const observer = new MutationObserver((mutations, obs) => {
        const table = document.querySelector('.hulkapps-table');
        if (table) {
            repositionHulkWidget();      // Eerst verplaatsen
            translateHulkWidget();       // Dan vertalen
            toggleCompanyAccountBlock(); // Dan company account block tonen
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Ook direct proberen na page load
    setTimeout(() => {
        repositionHulkWidget();
        translateHulkWidget();
        toggleCompanyAccountBlock();
    }, 2000);

    setTimeout(() => observer.disconnect(), 20000);

})();
